export default class DefaultCenter {
    latitude: number = 31.783333;
    longitude: number = 35.216667;
}